import {
  LOG_OUT,
  GET_VENDOR_ALL_OFFERS,
  GET_VENDOR_ALL_EVENTS,
  SET_ONLINE_EVENT_DETAILS_VENDOR,
  GET_ONLINE_EVENT_DETAILS_VENDOR,
  GET_ONLINE_VIEW_EVENT,
} from "../../types";

const initialState = {
  vendor_all_offers: [],
  vendor_all_events: [],
  set_all_online_event: {},
  get_all_online_events: [],
  get_view_online_events: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ONLINE_VIEW_EVENT:
      return {
        ...state,
        get_view_online_events: action.payload,
      };
    case GET_VENDOR_ALL_OFFERS:
      return {
        ...state,
        vendor_all_offers: action.payload,
      };
    case GET_VENDOR_ALL_EVENTS:
      return {
        ...state,
        vendor_all_events: action.payload,
      };
    case SET_ONLINE_EVENT_DETAILS_VENDOR:
      return {
        ...state,
        set_all_online_event: action.payload,
      };
    case GET_ONLINE_EVENT_DETAILS_VENDOR:
      return {
        ...state,
        get_all_online_events: action.payload,
      };
    case LOG_OUT: {
      return {
        ...state,
        vendor_all_offers: [],
        vendor_all_events: [],
      };
    }
    default:
      return state;
  }
}
